import React, { useEffect } from "react";
import "./RefundPolicy.css"; // Optional: add your styles here
import Header3 from "./components/Header3";
import Header from "./components/Header";
import Header2 from "./components/Header2";
import Header5 from "./components/Header5";

function RefundPolicy() {
  useEffect(() => {
    document.title = "Karamale Refund Policy";
  }, []);
  return (
    <>
      {localStorage.getItem("customername") !== null ? (
        <Header2 />
      ) : localStorage.getItem("businessname") !== null ? (
        <Header3 />
      ) : localStorage.getItem("partner") !== null ? (
        <Header5 />
      ) : (
        <Header />
      )}
      <div className="container">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-8 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search">
              <h3>Karamale Refund Policy</h3>

              <p>
                At Karamale, we strive to balance fairness and operational
                feasibility in every refund decision. Our structured refund
                policy ensures transparency for ticket buyers while safeguarding
                event organisers from last-minute cancellations and attendance
                manipulation.
              </p>

              <section>
                <h4>Eligibility Overview</h4>
                <ul>
                  <li>
                    Refunds can be requested up to the day before the event.
                  </li>
                  <li>
                    Tickets scanned at the venue are considered used and are not
                    eligible for refunds.
                  </li>
                  <li>A valid refund reason is required with each request.</li>
                </ul>
              </section>

              <section>
                <h4>Refund Fee Structure</h4>
                <table className="refund-table">
                  <thead>
                    <tr>
                      <th>Time Before Event</th>
                      <th>Refund Fee</th>
                      <th>Status</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>8+ days</td>
                      <td>Flat R10</td>
                      <td>PENDING</td>
                      <td>Refund request submitted successfully.</td>
                    </tr>
                    <tr>
                      <td>4–7 days</td>
                      <td>Flat R20</td>
                      <td>PENDING</td>
                      <td>Refund request submitted successfully.</td>
                    </tr>
                    <tr>
                      <td>1–3 days</td>
                      <td>25% + R15</td>
                      <td>PENDING</td>
                      <td>Refund request submitted successfully.</td>
                    </tr>
                    <tr>
                      <td>Same-day</td>
                      <td>Not permitted</td>
                      <td>DECLINED</td>
                      <td>Refunds are not allowed on the day of the event.</td>
                    </tr>
                    <tr>
                      <td>Scanned tickets</td>
                      <td>Not applicable</td>
                      <td>DECLINED</td>
                      <td>Ticket already used and not refundable.</td>
                    </tr>
                  </tbody>
                </table>
                <p className="fineprint">
                  * Refund amounts are calculated after fees and cannot exceed
                  the original ticket price.
                </p>
              </section>

              <section>
                <h4>Processing Timeline</h4>
                <ul>
                  <li>
                    Refunds are reviewed within <strong>5 business days</strong>
                    .
                  </li>
                  <li>
                    Approved refunds are paid within{" "}
                    <strong>7–10 working days</strong>.
                  </li>
                </ul>
              </section>

              <section>
                <h4>Exceptions & Overrides</h4>
                <p>
                  Event organisers may manually override refund restrictions for
                  exceptional circumstances, such as medical emergencies or
                  service interruptions. These overrides are securely logged and
                  subject to audit.
                </p>
              </section>

              <section>
                <h4>Support</h4>
                <p>
                  For any refund-related inquiries or disputes, please contact
                  our support team with your ticket ID and refund reason. We’re
                  here to help resolve issues fairly and efficiently.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RefundPolicy;
